import { createRef, useEffect } from 'react';

export const useDropdownKeys = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onOpen: (ref: any) => void,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onClose: (ref: any) => void
) => {
    const wrapperRef = createRef<HTMLDivElement>();

    useEffect(() => {
        const element = wrapperRef.current as HTMLElement;

        const handleKeyboardEvent = (ev: KeyboardEvent) => {
            if (ev.code === 'Escape') {
                ev.stopPropagation();
                ev.preventDefault();
                onClose(ref);
            } else if (ev.code === 'ArrowDown') {
                ev.stopPropagation();
                ev.preventDefault();
                onOpen(ref);
            }
        };

        element.addEventListener('keydown', handleKeyboardEvent);

        return () => element.removeEventListener('keydown', handleKeyboardEvent);
    }, [ref]);

    return {
        wrapperRef,
    };
};
